import React from 'react';
import { Hero } from './components/Hero';
import { SystemSection } from './components/SystemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ivory font-sans text-navy" data-id="element-0" data-mp="2mjzlp1wudjkz">
      <Hero data-id="element-1" data-mp="31bibtsjf0ui2" />
      <main data-id="element-2" data-mp="31c9u61o04vqe">
        <SystemSection data-id="element-3" data-mp="31ctdnmtavs6j" />
        <VolumesSection data-id="element-4" data-mp="2wk06ksad07ra" />
        <BonusSection data-id="element-5" data-mp="2wjqg73lejyl2" />
        <OfferSection data-id="element-6" data-mp="2wiferaffj2x4" />
        <FaqSection data-id="element-7" data-mp="2whxbhtucnofp" />
      </main>
      <SiteFooter data-id="element-8" data-mp="28tw6guwdqq51" />
      <PurchaseNotifications data-id="element-9" data-mp="28te0v7ntuzkg" />
    </div>;
}